/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Use_1_ValueInputs */

const en_svc_research_use_1_value = /** @type {(inputs: Svc_Research_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every new lead arrives with a short, sourced brief on who they are and why they might buy.`)
};

const lv_svc_research_use_1_value = /** @type {(inputs: Svc_Research_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katrs jauns potenciālais klients pienāk ar īsu kopsavilkumu ar avotiem: kas viņi ir un kāpēc varētu pirkt.`)
};

/**
* | output |
* | --- |
* | "Every new lead arrives with a short, sourced brief on who they are and why they might buy." |
*
* @param {Svc_Research_Use_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_use_1_value = /** @type {((inputs?: Svc_Research_Use_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Use_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_use_1_value(inputs)
	return en_svc_research_use_1_value(inputs)
});